import React, {Component} from 'react';
import {connect} from "react-redux";
import Login from "./Login";

export const ROLES = {
    COORDINATOR: "coordinator",
    REVIEWER: "reviewer",
    ADMIN: "admin",
    DEPARTMENTCOORDINATOR: "departmentCoordinator"

};

export const isAllowed = (user, compRoles) => {
    return user && user.roles && compRoles && user.roles.find(userRole => !!compRoles.find(compRole => compRole === userRole));
};

// assuming user have array of roles
export const withRoles = (compRoles) =>  (WrappedComponent) => {
    class AddRoleManagement extends Component {

        render() {
            if (isAllowed(this.props.user, compRoles)) {
                return (
                    <WrappedComponent {...this.props}/>
                );
            }
            else {
                // TODO: remember return url
                return <Login/>;
            }

        }
    }

    function mapStateToProps(state) {
        return {user: state.user};
    }

    return connect(mapStateToProps)(AddRoleManagement);
};
